/** Single shared avatar-monogram derivation — name initials when a real name
 *  exists, else the last two digits of the phone number. Used everywhere a
 *  customer avatar renders (chat header, message groups, inbox list) so the
 *  same customer always shows the same monogram (P0 fix — previously each
 *  call site had its own near-duplicate copy, and one caller incorrectly fed
 *  the phone number into the `name` slot, producing a different result). */
export function monogram(name?: string | null, phone?: string | null): string {
  const src = (name && name.trim()) || (phone ? phone.replace(/\D/g, '').slice(-2) : '');
  if (!src) return '·';
  const parts = src.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}
